export enum PrimatooModule{
	AI = 'AI',
	COVID = 'COVID',
	ENISA = 'ENISA',
	DATABREACH = 'DATABREACH',
	CHATBOT = 'CHATBOT',
	CYBERSEC = 'CYBERSEC',
	LIA = 'LIA',
	EXTRACTION = 'EXTRACTION',
	TICKET = 'TICKET',
	LOGIN_MS = 'LOGIN_MS',
	EXTERNAL_USER_MANAGEMENT = 'EXTERNAL_USER_MANAGEMENT',
}
